import styled from '@emotion/styled';

export const ErrorMessage = styled.div`
    color: #ee746c;
    text-align: center;
`;
